import styled from "styled-components";
import { Input } from "antd";
import { theme } from "../../../config";
const { TextArea } = Input;

export const TextAreaStyled = styled(TextArea)`
  ${theme.defaultInputStyle}
  &.ant-input[disabled] {
    color: ${theme.colors.neutral.black3};
    background-color: ${theme.colors.neutral.black7};
    border: 1px solid #AAAAAA;
  }
  @media ${theme.breakpoints.mobileAndTablet} {
    height: 30px;
    font-size: 12.6px;
    line-height: 16px;
  }
`;
